<script setup lang="ts">
import { ref, computed } from 'vue';
import LoadingStatus from '@/assets/js/enum/LoadingStatus';
import LoaderButton from '@/components/display/button/LoaderButton.vue';
import MainContentPanel from '@/components/display/general/MainContentPanel.vue';
import BreadCrumb from '@/components/general/BreadCrumb.vue';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { xhr } from '@/xhr/endpoints';
import { useState } from '@/composables/useVuexHelpers';
import router from '@/router';

const { idToken } = useState(['idToken']);

const form = ref({
  name: '',
});

const formFields = ref({
  name: {
    type: 'text',
    placeholder: 'e.g. Matador Enterprises',
  },
});

const savingStatus = ref('');

const rules = computed(() => ({
  name: { required },
}));

const $v = useVuelidate(rules, form);

const submitForm = async () => {
  savingStatus.value = LoadingStatus.LOADING;

  try {
    await xhr.createOrganization(form.value.name, idToken.value);
    savingStatus.value = LoadingStatus.SUCCESS;
    router.push('/organizations');
  } catch {
    savingStatus.value = LoadingStatus.FAILED;
  }
};
</script>

<template>
  <div class="uk-flex full-width">
    <div class="uk-column-1-1 uk-flex uk-flex-column full-width">
      <BreadCrumb
        :path="[
          {
            title: 'My Organizations',
            route: '/organizations',
          },
          {
            title: 'Create Organization',
            route: '/organization/create',
          },
        ]"
      />
      <MainContentPanel title="Create a New Organization">
        <form class="uk-flex uk-flex-column">
          <form-group
            class="uk-margin uk-width-1-1"
            :class="{ error: $v.name.$error }"
            :validator="$v.name"
          >
            <span class="uk-inline uk-width-3-5">
              <span class="uk-text-bolder uk-text-large"> Organization Name: </span>
              <input
                class="uk-input"
                :type="formFields.name.type"
                :placeholder="formFields.name.placeholder"
                v-model="form.name"
                required
                @input="$v.name.$touch()"
              />
            </span>
          </form-group>

          <div class="uk-margin-top uk-width-1-1">
            <LoaderButton
              class="uk-margin-top uk-button-default uk-padding-small uk-button-small"
              icon="arrow-right"
              :loaderStatus="savingStatus"
              :disabled="$v.$invalid"
              @click="submitForm"
              @keypress.enter="submitForm"
              >Create</LoaderButton
            >
          </div>
        </form>
      </MainContentPanel>
    </div>
  </div>
</template>
